import BaseModelAPI from '../BaseModelAPI';

export default class PostList extends BaseModelAPI {

	static entity = 'postlist'
	static entityName = 'post';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
